<template>
  <transition
    enter-active-class="transition ease-out duration-100"
    enter-from-class="transform opacity-0 scale-95"
    enter-to-class="transform opacity-100 scale-100"
    leave-active-class="transition ease-in duration-75"
    leave-from-class="transform opacity-100 scale-100"
    leave-to-class="transform opacity-0 scale-95"
  >
    <div
      v-if="dropdownV2.isOpen"
      class="aha-dropdown-menu-ai"
      :class="classes"
      :style="{ width }"
      :aria-label="ariaLabel"
    >
      <div role="menu" aria-orientation="vertical">
        <slot />
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'DropdownMenu',
  inject: ['dropdownV2'],
  props: {
    ariaLabel: {
      type: String,
      default: 'Dropdown menu',
    },
    width: {
      type: String,
      default: '100%',
    },
    classes: {
      type: String,
      default: '',
    },
  },
}
</script>
<style lang="scss" scoped>
.aha-dropdown {
  position: relative;
  width: max-content;
}

.aha-dropdown-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px;
  background-color: white;
  border: none;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: background-color 0.2s;
}

.aha-dropdown-trigger:hover {
  background-color:#E6E6E6
}

.aha-dropdown-trigger.active {
  background:#E6E6E6;
}

.aha-dropdown-menu-ai {
  padding: 4px;
  position: absolute;
  overflow-x: hidden;
  top: calc(100% + 12px);
  left: 0;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 9px 28px 8px #0000000D;
  z-index: 50;
}

</style>
